import './fonts'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { AuthProvider } from '@better-auth-ui/react'
import { Toaster } from '@/components/ui/sonner'
import { adminPlugin } from '@/lib/auth/admin-plugin'
import { authClient } from '@/lib/auth-client'
import { queryClient } from '@/lib/query-client'
import { roleNames } from '../shared/permissions'
import { routeTree } from './routeTree.gen'

const router = createRouter({ routeTree, defaultPreload: 'intent' })

declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router
	}
}

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		{/* better-auth-ui (Staff page). Its sign-in redirects resolve to /login?redirectTo=… */}
		<AuthProvider
			authClient={authClient}
			queryClient={queryClient}
			plugins={[adminPlugin({ roles: roleNames })]}
			basePaths={{ auth: '', admin: '/staff' }}
			viewPaths={{ auth: { signIn: 'login' } }}
			redirectTo="/"
			navigate={({ to, replace }) => (replace ? router.history.replace(to) : router.history.push(to))}
		>
			<RouterProvider router={router} />
			<Toaster richColors position="top-right" />
		</AuthProvider>
	</StrictMode>
)
